import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";

import { onChange } from "./helpers/on-change"

const DEFAULT_LINE_HEIGHT: string = "properties.styles.$deviceType.lineHeight";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const LineHeight = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_LINE_HEIGHT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.lineHeight) {
        setValue(computedStyles.lineHeight)
        setOldValue(computedStyles.lineHeight)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_LINE_HEIGHT.split("."), deviceType), computedStyles]);

  return (
    <div className="panel-div">
      <label
        htmlFor="lineheight"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
        disabled={!isCheckedIn}
        type="number"
        id="lineheight"
        value={value}
        className="panel-input"
        placeholder="0"
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_LINE_HEIGHT,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
};
